import React from 'react'

const LargeIconStyle = {
  pointerEvents: "none",
  fontSize: "6rem",
  fontWeight: "bold",
  color: "#000000",
  textShadow: "0 0 12px #f5f5f54f",
}

const PausedVideoStyle = {
  height: "auto",
}

export {
  LargeIconStyle,
  PausedVideoStyle,
}